import './index.erb';
import './index.rb';
import s from './index.module.scss';

export default class CtaStatusBased {
  constructor(context) {
    this.context = context;
    this.downloadForm = this.context.querySelector(`.${s.downloadTrigger}`);
    this.answersDownloadTrigger = this.context.querySelector(
      `.${s.answersDownload}`
    );
    this.bind();
  }

  download(url) {
    window.open(url, '_blank');
  }

  reloadWithTracking(e) {
    const target = e.target;
    const targetData = target.dataset;

    let trackingParams = new URLSearchParams();
    trackingParams.set('utm_source', targetData.trackingSource);
    trackingParams.set('utm_medium', targetData.trackingMedium);
    trackingParams.set('utm_campaign', targetData.trackingCampaign);
    trackingParams.set('utm_term', targetData.trackingTerm);

    location.search = trackingParams.toString();
  }

  bind() {
    if (this.downloadForm) {
      this.downloadForm.onsubmit = (e) => {
        let url = this.downloadForm.dataset.downloadUrl;
        this.download(url);
        setTimeout(() => this.reloadWithTracking(e), 2000);
      };
    }

    if (this.answersDownloadTrigger) {
      this.answersDownloadTrigger.addEventListener('click', (e) => {
        let url = this.answersDownloadTrigger.dataset.downloadUrl;
        this.download(url);
        this.reloadWithTracking(e);
      });
    }
  }
}
